import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { axiosInstance } from "../axiosConfig";

const HeaderComponent = ({ role }) => {
  const handleLogout = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}/user/logout`, {
        headers: {
          Authorization: `${localStorage.getItem("accessToken")}`,
        },
      })
      .then(() => {
        localStorage.removeItem("role");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <HeaderLayout>
      <HeaderButton to="/">
        <span className="blue">KRPT</span>
        &nbsp; 안전문서 등록 시스템
      </HeaderButton>
      <UserLayout>
        {role === "admin" && <UserButton to="/admin">관리자</UserButton>}
        <UserButton to="/user">내 정보</UserButton>
        <UserButton onClick={handleLogout}>로그아웃</UserButton>
      </UserLayout>
    </HeaderLayout>
  );
};

const HeaderLayout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: var(--color-main);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);

  .blue {
    color: var(--color-blue);
  }
`;

const UserLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 1rem;
`;

const HeaderButton = styled(Link)`
  margin-left: 30px;
  font-size: var(--font-size-title);
  font-weight: bold;
  border: none;
  background-color: transparent;
  color: var(--color-white);
  cursor: pointer;
  text-decoration: none;
`;

const UserButton = styled(Link)`
  padding: 0 10px;
  font-size: var(--font-size-small);
  border: none;
  background-color: transparent;
  color: var(--color-white);
  cursor: pointer;
`;

export default HeaderComponent;
